import React from "react";
import Team from "../components/Team";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function TeamPage() {
  return (
    <>
      <Team />
    </>
  );
}
